// extracted by mini-css-extract-plugin
module.exports = {"HitList":"HitsList_HitList__QwtRY","LoaderContainer":"HitsList_LoaderContainer__3XtRV"};